@if (uiController === UIControlTyp.MultiSelectList) {
  <kendo-multiselect
    textField="name"
    valueField="id"
    [data]="AzurePersonList"
    [filterable]="true"
    (filterChange)="filterAzurePersons($event)"
    (valueChange)="valueChanged($event)"
    placeholder="Wählen Sie einen User aus!"
    [(ngModel)]="AzurePersons">
    @if (false; as dataItem) {
      <ng-template kendoDropDownListItemTemplate let-dataItem>
        <img src="{{ dataItem.image }}" alt="picture" width="40"> {{ dataItem.name }}
      </ng-template>
    }
  </kendo-multiselect>
}
@if (uiController === UIControlTyp.DropDownList) {
  <kendo-dropdownlist
    class="fdb-kendo-dropdown"
    textField="name"
    valueField="id"
    [valuePrimitive]="true"
    [data]="AzurePersonList"
    [value]="SelectedAzurePersonId"
    (valueChange)="valueChanged($event)">
    @if (false; as dataItem) {
      <ng-template kendoDropDownListItemTemplate let-dataItem>
        <img src="{{ dataItem.image }}" alt="" width="40"> {{ dataItem.name }}
      </ng-template>
    }
  </kendo-dropdownlist>
}
@if (uiController === UIControlTyp.GridSingleValueField) {
  {{ DisplayName }}
}
